import { createFileRoute } from '@tanstack/react-router';

import ScorecardTrackingDetailPage from '../../views/dashboard-scorecard-tracking-detail';

export const Route = createFileRoute('/dashboard/scorecard/watchlist_/$uuid')({
  component: ScorecardTrackingDetailPage,
});
